module.exports = __webpack_public_path__ + "img/a3.701daf69.png";